import { IS_PROD, BRAND_REQUEST_TEMPLATE_BASE_URL } from "./env";

export const LOCAL_STORAGE = {
  TOKEN_NAME: "token",
};

export const authConstants = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",

  LOGOUT: "LOGOUT",
  RESET_HAS_LOGGED_OUT: "RESET_HAS_LOGGED_OUT",
  RESET_LOGIN: "RESET_LOGIN",

  UPDATE_BRAND_DATA: "UPDATE_BRAND_DATA",
};

export const resetPasswordConstants = {
  FORGOT_PASSWORD_REQUEST: "FORGOT_PASSWORD_REQUEST",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAIL: "FORGOT_PASSWORD_FAIL",

  VALIDATE_RESET_PASS_TOKEN_REQUEST: "VALIDATE_RESET_PASS_TOKEN_REQUEST",
  VALIDATE_RESET_PASS_TOKEN_SUCCESS: "VALIDATE_RESET_PASS_TOKEN_SUCCESS",
  VALIDATE_RESET_PASS_TOKEN_FAIL: "VALIDATE_RESET_PASS_TOKEN_FAIL",

  RESET_PASSWORD_REQUEST: "RESET_PASSWORD_REQUEST",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
  RESET_PASSWORD_FAIL: "RESET_PASSWORD_FAIL",

  RESET_STATE: "RESET_STATE",
};

export const userConstants = {
  GET_USER_REQUEST: "GET_USER_REQUEST",
  GET_USER_SUCCESS: "GET_USER_SUCCESS",
  GET_USER_FAIL: "GET_USER_FAIL",
  UPDATE_USER_REQUEST: "UPDATE_USER_REQUEST",
  UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
  UPDATE_USER_FAIL: "UPDATE_USER_FAIL",
};

export const brandConstants = {
  SET_GLOBAL_BRAND: "SET_GLOBAL_BRAND",

  GET_PAGE_SETUP_REQUEST: "GET_PAGE_SETUP_REQUEST",
  GET_PAGE_SETUP_SUCCESS: "GET_PAGE_SETUP_SUCCESS",
  GET_PAGE_SETUP_FAIL: "GET_PAGE_SETUP_FAIL",

  GET_BRANDS_REQUEST: "GET_BRANDS_REQUEST",
  GET_BRANDS_SUCCESS: "GET_BRANDS_SUCCESS",
  GET_BRANDS_FAIL: "GET_BRANDS_FAIL",
};

export const campaignConstants = {
  SAVE_DRAFT_REQUEST: "SAVE_DRAFT_REQUEST",
  SAVE_DRAFT_POSTCARD_REQUEST: "SAVE_DRAFT_POSTCARD_REQUEST",
  SAVE_DRAFT_SUCCESS: "SAVE_DRAFT_SUCCESS",
  SAVE_DRAFT_FAIL: "SAVE_DRAFT_FAIL",

  RESET_IS_DRAFT_SUCCESS: "RESET_IS_DRAFT_SUCCESS",

  GET_CAMPAIGN_REPORT_REQUEST: "GET_CAMPAIGN_REPORT_REQUEST",
  GET_CAMPAIGN_REPORT_SUCCESS: "GET_CAMPAIGN_REPORT_SUCCESS",
  GET_CAMPAIGN_REPORT_FAIL: "GET_CAMPAIGN_REPORT_FAIL",
  RESET_ERROR: "RESET_ERROR",

  SET_JOIN_CAMP_TNC_CHECKED: "SET_JOIN_CAMP_TNC_CHECKED",
};

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

export const FILE_TYPE_MIME_TYPE = {
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
};

export const AUTO_LOGOUT = {
  CHANNEL_NAME: "tabReloadChannel",
};

export const settingsConstants = {
  SET_SETTINGS: "SET_SETTINGS ",
  GET_SETTINGS: "GET_SETTINGS",
};

export const themeConstants = {
  SET_THEME: "SET_THEME",
  GET_THEME: "GET_THEME",
};

export const MAILING_TYPES = {
  S: "saturated",
  T: "targeted",
};

export const LocSubsStatus = {
  UNSUBSCRIBED: "Unsubscribed",
  FALLOUT: "FallOut",
  LESS_THAN_30: "SubscriptionRemainedLessThan30Days",
  IS_CREATIVE: "Creatives are not available",
};

export const CUSTOM_WIDGET_PARAM = {
  LocationID: "LocationID",
  BrandID: "BrandID",
  CampaignID: "CampaignID",
  ParticipantID: "ParticipantID",
  GroupID: "GroupID",
  StartDate: "StartMonth",
  EndDate: "EndMonth",
};

export const subscriptionPlanLength = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 18,
];

export const brandsWithCsvDownloadOption = [
  "BD393497", // The Salad Station
  "BD702554", // Top Rail Fence
  "BD201330", // Window Hero
  "BD674975", // The Designery
  "BD416667", // Anytime Fitness
  "BD371710", // Waxing the City
  "BD372455", // Do it Best
  "BD793200", // Papa Murphy's
  "BD822958", // Discover Strength
  "BD235520", // The Peach Cobbler Factory
  "BD653181", // 	Tupelo Honey
];

export const subscriptionPlanFeeType = {
  SUB_FEE_AND_MEDIA_COST: "1", // "Subscription fee + media cost",
  MEDIA_COST_ONLY: "2", // "Media cost only",
  SUB_FEE_ONLY: "3", //"Subscription fee only",
};

export const subscriptionPlanPaymentType = {
  INVOICE: "invoice",
  STRIPE: "stripe",
};

export const subscriptionPaymentStatus = {
  UNPAID: "1",
  PENDING: "2",
  PAID: "3",
};

export const stripeSubscriptionStatus = {
  ACTIVE: "1",
  INCOMPLETE: "2",
  INCOMPLETE_EXPIRED: "3",
  PAST_DUE: "4",
  CANCELED: "5",
  EXPIRED: "6",
};

export const FILTERS = {
  YTD: "ytd",
  LAST_QUARTER: "last_quarter",
  CUSTOM: "custom",
};

export const DRILL_LEVELS = {
  YEAR: "year",
  QUARTER: "quarter",
  MONTH: "month",
  DAY: "day",
};

export const WIDGETS_WITH_DRILL_FEATURE = [
  29, 30, 33, 44, 45, 46, 47, 48, 56, 72, 73, 74, 75, 76, 99, 107, 111, 112,
  113, 114, 115, 132, 134, 137,
];

/**
 * @constant
 * @description brands have drill feature
 * add 'all' to display to all brands
 * BD301908 Ana Test Brand
 * BD832735 THE TEN SPOT
 * BD175207 Popeyes Louisiana Kitchen
 */
export const BRANDS_HAVE_DRILL_FEATURE = ["BD301908", "BD832735", "BD175207"]; // add 'all' to display to all brands

/**
 * @constant
 * @description advanced setting question types
 */
export const ADVANCED_SETTING_Q_TYPE = {
  SHORT_ANSWER: "short_answer",
  LONG_ANSWER: "paragraph",
  PRODUCT: "product",
  ATTACHMENT: "attachment",
  MULTI_SELECTOR: "multiple_selection",
  RADIUS: "radius",
};

/**
 * @constant QUESTION_TYPE_RADIUS
 * @description properties of the question type radius
 */
export const QUESTION_TYPE_RADIUS = {
  MIN: 1,
  MAX: 25,
};

export const BRAND_REQUEST_TYPE = {
  ADD_LOCATION: "Add Location",
  CREATIVE_REQUEST: "Creative Request",
  BUDGET_APPROVAL_CONFIRMATION_REQUEST:
    "Budget Approval / Confirmation / Request",
  PAUSE_REQUEST_CLOSED_LOCATION: "Pause Request / Closed Location",
  NEW_STORE_OPENING: "New Store Opening",
  NEW_CAMPAIGN: "New Campaign",
  GENERAL_REQUEST: "General Request",
  REPORT_REQUEST: "Report Request",
  TARGETING_CHANGES: "Targeting Changes",
  BRAND_MEETING_NOTES_EVENT_REPORTS: "Brand Meeting Notes/ Event Reports",
};

export const BOOST_CAMP_PAY_TYPE = {
  INVOICE: "invoice",
  STRIPE: "credit",
};

export const USER_ROLE = {
  SUPER_ADMIN: {
    ID: 1,
    NAME: "SA",
    TEXT: "Super Admin",
  },
  PARENT_COMPANY: {
    ID: 2,
    NAME: "PC",
    TEXT: "Parent Company",
  },
  BRAND_OWNER: {
    ID: 3,
    NAME: "BO",
    TEXT: "Brand Owner",
  },
  PARTICIPANT: {
    ID: 4,
    NAME: "PR",
    TEXT: "Participant",
  },
  BRAND_USER: {
    ID: 5,
    NAME: "BU",
    TEXT: "Brand User",
  },
  PARENT_COMPANY_USER: {
    ID: 6,
    NAME: "PCU",
    TEXT: "Parent Company User",
  },
  PARENT_COMPANY_SUB_USER: {
    ID: 7,
    NAME: "PCSU",
    TEXT: "Parent Company Sub User",
  },
  SUB_PARTICIPANT: {
    ID: 8,
    NAME: "PR",
    TEXT: "Sub Participant",
  },
};

export const BRAND_CONST = {
  STATUS: {
    ACTIVE: {
      ID: 1,
      NAME: "Active",
      TEXT: "Active",
      TYPE: "success",
    },
    INACTIVE: {
      ID: 2,
      NAME: "Inactive",
      TEXT: "Inactive",
      TYPE: "error",
    },
    SUBSCRIBED: {
      ID: 3,
      NAME: "Subscribed",
      TEXT: "Subscribed",
      TYPE: "success",
    },
    UNSUBSCRIBED: {
      ID: 4,
      NAME: "Unsubscribed",
      TEXT: "Unsubscribed",
      TYPE: "error",
    },
  },
  MS_BRAND_ID: 1,
  KUMON_BRAND_ID: 2,
  JINYA_RAMEN_BAR_BRAND_ID: IS_PROD ? 3 : "",
  THE_TEN_SPOT_BRAND_ID: IS_PROD ? 26 : "",
  POPEYES_BRAND_ID: IS_PROD ? 86 : "",
  POPEYES_LOUISIANA_KITCHEN_CANADA_BRAND_ID: IS_PROD ? 112 : "",
  PAPA_MURPHY_BRAND_ID: IS_PROD ? 72 : "",
  DOMINO_DEMO_BRAND_ID: IS_PROD ? 95 : "",
  DOMINOS_BRAND_ID: IS_PROD ? 117 : "",
  PEETS_COFFEE_BRAND_ID: IS_PROD ? 99 : "",
  JACK_IN_THE_BOX_BRAND_ID: IS_PROD ? 101 : "",
  BURGER_KING_BRAND_ID: IS_PROD ? 104 : "",
  JASON_DELI_BRAND_ID: IS_PROD ? 109 : "",
  CORNER_BAKERY_BRAND_ID: IS_PROD ? 110 : "",
  CICIS_PIZZA_BRAND_ID: IS_PROD ? 111 : "",
  DISCOVER_STRENGTH_BRAND_ID: IS_PROD ? 77 : "",
  BOARD_AND_BRUSH_BRAND_ID: IS_PROD ? 91 : "",
  BUCA_DI_BEPPO: IS_PROD ? 115 : "",
  PAPA_JOHNS: IS_PROD ? 116 : "",
  PIZZA_BRAND_ID: IS_PROD ? 120 : "",
  TIJUANA_FLATS_BRAND_ID: IS_PROD ? 121 : "",
};

export const isBrandSubUserAllowed = (brand) =>
  brand?.sub_user_allowed === true ||
  brand?.sub_user_allowed === 1 ||
  brand?.sub_user_allowed === "1" ||
  brand?.sub_user_allowed === "true";

/**
 * @constant
 * @description campaign constants
 */
export const CAMPAIGN_CONST = {
  TYPE: {
    NORMAL: "Normal",
    EVERGREEN: "Evergreen",
  },
  BUDGET_TYPE: {
    LOCATION_SPECIFIC: "Location Specific",
    PRESET: "Pre-set",
  },
  BUFFER: {
    BOOST_BUSINESS_DAYS_DEFAULT: 2,
  },
  STATUS: {
    ACTIVE: {
      ID: 1,
      NAME: "Active",
      TEXT: "Live",
    },
    SCHEDULED: {
      ID: 2,
      NAME: "Scheduled",
      TEXT: "Scheduled",
    },
    COMPLETED: {
      ID: 3,
      NAME: "Completed",
      TEXT: "Completed",
    },
    PAUSED: {
      ID: 4,
      NAME: "Paused",
      TEXT: "Paused",
    },
    INACTIVE: {
      ID: 0,
      NAME: "Inactive",
      TEXT: "Inactive",
    },
    DRAFT: {
      ID: 5,
      NAME: "Draft",
      TEXT: "Draft",
    },
    DELIVERED: {
      ID: 6,
      NAME: "Delivered",
      TEXT: "Delivered",
    },
  },
  POSTCARD: {
    TYPE: {
      EVERGREEN: "EVERGREEN",
      LIMITED: "LIMITED",
    },
  },
  HIDE_CAMPAIGN_BUDGET: [BRAND_CONST.JINYA_RAMEN_BAR_BRAND_ID],
  AVAILABILITY_WINDOW: {
    TYPE: {
      SINGLE: "single_window",
      MULTIPLE: "multiple_window",
      ALWAYS_AVAILABLE: "always_available",
    },
  },
  EXTEND: {
    MIN_EXTEND_DAYS: 5,
  },
};

export const CHANNELS = {
  SEARCH: {
    id: 1,
    name: "Search",
    lowerCaseName: "search",
  },
  PMAX: {
    id: 17,
    name: "PMax",
    lowerCaseName: "pmax",
  },
};

export const BRAND_REQUEST_TEMPLATE_URL = {
  BUDGET_SHEET: `${BRAND_REQUEST_TEMPLATE_BASE_URL}/Budget_Sheet_Template.xlsx`,
  LOCATION_UPLOAD_SHEET: `${BRAND_REQUEST_TEMPLATE_BASE_URL}/Location_Upload_Sheet_Template.xlsx`,
  SEARCH_CREATIVE_TEMPLATE: `${BRAND_REQUEST_TEMPLATE_BASE_URL}/Search_Creative_Template_RSA.xlsx`,
  SOCIAL_AD_COPY_TEMPLATE: `${BRAND_REQUEST_TEMPLATE_BASE_URL}/Social_Ad_Copy_Template.xlsx`,
  CREATIVE_SPECIFICATION_TEMPLATE: `${BRAND_REQUEST_TEMPLATE_BASE_URL}/Creative_Specs_Template.pdf`,
};

export const SUBSCRIPTION_CONST = {
  STATUS: {
    SUBSCRIBED: {
      NAME: "Subscribed",
      TEXT: "Enrolled",
      TYPE: "info",
    },
    UNSUBSCRIBED: {
      NAME: "Unsubscribed",
      TEXT: "Not Enrolled",
      TYPE: "warn",
    },
    ACTIVE: {
      NAME: "Active",
      TEXT: "Active",
      TYPE: "success",
    },
    INACTIVE: {
      NAME: "Inactive",
      TEXT: "Inactive",
      TYPE: "error",
    },
    PAST_DUE: {
      NAME: "Past Due",
      TEXT: "Past Due",
      TYPE: "error",
    },
    UPCOMING_RENEWAL: {
      NAME: "Upcoming Renewal",
      TEXT: "Upcoming Renewal",
      TYPE: "info",
    },
    RENEWED: {
      NAME: "Renewed",
      TEXT: "Renewed",
      TYPE: "success",
    },
    AUTO_RENEW_ON: {
      NAME: "Auto-Renew ON",
      TEXT: "Auto-Renew ON",
      TYPE: "arStatus",
    },
    AUTO_RENEW_OFF: {
      NAME: "Auto-Renew OFF",
      TEXT: "Auto-Renew OFF",
      TYPE: "error",
    },
    PAYMENT_PENDING: {
      NAME: "Payment Pending",
      TEXT: "Payment Pending",
      TYPE: "error",
    },
    FALLOUT: {
      NAME: "Fallout",
      TEXT: "Campaign Dates are Outside Subscription Period",
      TYPE: "warn",
    },
    EXPIRED: {
      NAME: "Expired",
      TEXT: "Expired",
      TYPE: "error",
    },
  },
  SUBSCRIPTION_LENGTH_OPTIONS: Array.from(
    { length: 12 },
    (_, index) => index + 1
  )
    .map((length) => ({
      LABEL: `${length} Months`,
      VALUE: length.toString(),
    }))
    ?.concat([
      {
        LABEL: "15 Months",
        VALUE: "15",
      },
      {
        LABEL: "18 Months",
        VALUE: "18",
      },
    ]),
};

export const SOCKET_CONST = {
  EVENT_TYPE: {
    BRAND_COVER_UPDATE: "brand-cover-update",
  },
  ACTION: {
    LOGOUT: "logout",
    RELOAD: "reload",
  },
};

export const REDIRECT_CONST = {
  WHITE_LIST_SUBDOMAINS: ["app", "dev-app", "qa-app"],
  PROD_SUBDOMAINS: ["app"],
  DEV_SUBDOMAINS: ["dev-app"],
  QA_SUBDOMAINS: ["qa-app"],
};

export const DATE_CONST = {
  INFINITY_DATE: "9999-12-31",
};

type LocationStatusEntry = {
  ID: number;
  LABEL: string;
};

type LocationStatusConst = {
  BY_LABEL: Record<string, number>;
  CLOSED: LocationStatusEntry;
  DEFAULT: string;
  LABEL_BY_ID: Record<number, string>;
  OPEN: LocationStatusEntry;
  OPTIONS: string[];
  TEMPORARILY_CLOSED: LocationStatusEntry;
};

export const LOCATION_STATUS_CONST = {
  OPEN: {
    ID: 1,
    LABEL: "Open",
  },
  TEMPORARILY_CLOSED: {
    ID: 2,
    LABEL: "Temporarily Closed",
  },
  CLOSED: {
    ID: 3,
    LABEL: "Closed",
  },
} as LocationStatusConst;

LOCATION_STATUS_CONST.DEFAULT = LOCATION_STATUS_CONST.OPEN.LABEL;
LOCATION_STATUS_CONST.OPTIONS = [
  LOCATION_STATUS_CONST.OPEN.LABEL,
  LOCATION_STATUS_CONST.TEMPORARILY_CLOSED.LABEL,
  LOCATION_STATUS_CONST.CLOSED.LABEL,
];
LOCATION_STATUS_CONST.BY_LABEL = {
  [LOCATION_STATUS_CONST.OPEN.LABEL]: LOCATION_STATUS_CONST.OPEN.ID,
  [LOCATION_STATUS_CONST.TEMPORARILY_CLOSED.LABEL]:
    LOCATION_STATUS_CONST.TEMPORARILY_CLOSED.ID,
  [LOCATION_STATUS_CONST.CLOSED.LABEL]: LOCATION_STATUS_CONST.CLOSED.ID,
};
LOCATION_STATUS_CONST.LABEL_BY_ID = {
  [LOCATION_STATUS_CONST.OPEN.ID]: LOCATION_STATUS_CONST.OPEN.LABEL,
  [LOCATION_STATUS_CONST.TEMPORARILY_CLOSED.ID]:
    LOCATION_STATUS_CONST.TEMPORARILY_CLOSED.LABEL,
  [LOCATION_STATUS_CONST.CLOSED.ID]: LOCATION_STATUS_CONST.CLOSED.LABEL,
};

/**
 * @constant TIMEOUTS
 * @description Timeout durations used across the application
 */
export const TIMEOUTS = {
  TOAST_DURATION: 4000,
  SNACKBAR_DURATION: 4000,
  SNACKBAR_SHORT: 2000,
};

/**
 * @constant VALIDATION_LIMITS
 * @description Validation limits for form fields and inputs
 */
export const VALIDATION_LIMITS = {
  MAX_STORE_COPY_QNT: 50000,
  MAX_NUMBER_FIELD_DEFAULT: 100000,
  MAX_NUMBER_FIELD: 1000000,
};

export const CANADA_COUNTRY_VALUES = ["CA", "CANADA"];
export const CANADA_PAYMENT_METHOD = {
  CREDIT_CARD: "credit_card",
  PAD: "pad",
};
